import { render, staticRenderFns } from "./notifications-view.vue?vue&type=template&id=7c03751a&"
import script from "./notifications-view.vue?vue&type=script&lang=ts&"
export * from "./notifications-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports